export enum DesiredIndex {
	FirstItem,
	LastItem,
	NthItem,
}
